/**
 *  App Constants
 */
(function (itxApp) {

    'use strict';

    var ItxConstants = {
        debug: false,
        //Name for the stores variable in local storage indicating if
        //the columns expanded button is pressed
        layoutExpandedKey: 'LAYOUT_EXPANDED',
        //Key for store in localStorage de current category filter
        DuttiCategoryFilterKey: 'DUTTI_CategoryFilter',
        DuttiLowThreshold: 'DUTTI_UMBRAL_BAJO',
        //Image types
        //Get the image size using ONLY the ItxUtilsFct.getImageType fn
        imageTypes: {
            //Main image type
            main: 1,
            //Alternative image type
            alternative: 2,
            //Color type
            color: 3,
            siluet: 4,
            siluet2: 5, 
            //alternative image type in grid
            altImg: 6,
            //Landscape type
            doubleBox: 7,
            //LookBook type
            lookBook: 9,
           
            //Lookbook detail products
            lookBookProduct: 16,
            //video
            video: 8,
            //No model
            noModel: 17,
            superBox: 10,
            verticalBox:11,
            doubleBoxBanner: 13,
            superBoxBanner: 14
            
        },
       

        //Image sizes
        //Get the image size using ONLY the ItxUtilsFct.getImageSize fn
        imageSizes: {
            doubleGrid: {xs: 'd13', sm: 'd14', md: 'd13',md2: 'd13', md3: 'd13', lg: 'd14', lg2: 'd15', highRes: 'd16'},
            //Grid main image
            grid: {xs: 16, sm: 16, md: 16, lg: 16, highRes: 16},
            //Colors
            color: {xs: 7, sm: 7, md: 7, lg: 7, highRes: 7},
            //Order item image
            orderItem: {xs: 16, sm: 16, md: 16, lg: 16, highRes: 16},
            shopCart: {xs: 16, sm: 16, md: 16, lg: 16, highRes: 16},
            //ProductBean detail images
            product: {xs: 13, sm: 14, md: 14, lg: 14, highRes: 16},
            //When the ProductBean has only one image
            productUnique: {xs: 13, sm: 14, md: 14, lg: 15, highRes: 16},
            //Zoomed product images
            zoom: {xs: 16, sm: 16, md: 16, lg: 16, highRes: 16},
            //BundleBean main image
            bundleLook: {xs: 13, sm: 14, md: 15, lg: 15, highRes: 16},
            //BundleBean related images
            bundleProducts: {xs: 13, sm: 13, md: 13, lg: 13, highRes: 13},
            //Related products images
            related: {xs: 3, sm: 3, md: 13, lg: 13, highRes: 13},
            //Social Links
            social: {xs: 2, sm: 2, md: 2, lg: 2, highRes: 2},
            //LookBook image
            lookBook: {xs: 13, sm: 13, md: 13, lg: 13, highRes: 13}
        },
        //xmediaLocation types
        //Get the image size using ONLY the ItxUtilsFct.getImageType fn
        xmediaLocations: {
            //category photo
            categoryPage: 0,
            //product detail photo
            productPage: 1,
            //multipurpose photo: checkout, myAccount, order
            checkout: 2,
            //color cut photo
            colorcut: 3,
            //related product photo
            relatedProduct: 4,
            //bundles product photo
            bundleComponent: 5
        },

        //xmediaSizes types
        //Get the image size using ONLY the ItxUtilsFct.getImageType fn
        xmediaSizes: {
            2: {height: 1733, width: 1300},
            3: {height: 485, width: 364},
            d3: {height: 192, width: 364},
            4: {height: 180, width: 135},
            5: {height: 121, width: 91},
            7: {height: 12, width: 45},
            13: {height: 746, width: 560},
            d13: {height: 296, width: 560},
            14: {height: 1306, width: 980},
            d14: {height: 518, width: 980},
            15: {height: 1706, width: 1280},
            d15: {height: 634, width: 1200},
            16: {height: 1866, width: 1400},
            d16: {height: 740, width: 1400},
        },  

        xmediaFormats:{
            JPG: 1,
            MP4: 4
        },

        //idMedia - clazz correlation
        idMedia: {
            7: ['7_1']
        },
        //Slider configuration
        sliders: {
            product: {item:1, enableTouch:true, vertical: true, freeMove: false},
            related: {item:4, enableTouch:true, pager: false, responsive: [
                {breakpoint: 1280, settings: {item: (inditex.iPage === 'ItxProductPage' ? 2 : 4)}},
                {breakpoint: 992, settings: {item: 4}},
                {breakpoint: 768, settings: {item: 2}}
            ]},
            orderItem: {item:2, enableTouch:true, freeMove: false}
        },

        //Category types
        categoryTypes: {
            subHome: [2, 5],
            lookBook: [1, 17, 26]
        },

        //Marker images
        markerImages: {
            store: {
                markerOn: '/static/itxwebstandard/images/tienda-on.png',
                markerOnSm: '/static/itxwebstandard/images/tienda-on-small.png',
                markerOff: '/static/itxwebstandard/images/tienda-off.png',
                markerOffSm: '/static/itxwebstandard/images/tienda-off-small.png',
                markerFavOn: '/static/itxwebstandard/images/tienda-favorita-on.png',
                markerFavOnSm: '/static/itxwebstandard/images/tienda-favorita-on-small.png',
                markerFavOff: '/static/itxwebstandard/images/tienda-favorita-off.png',
                markerFavOffSm: '/static/itxwebstandard/images/tienda-favorita-off-small.png'
            },
            droppoint: {
                markerOn: '/static/itxwebstandard/images/tienda-on.png',
                markerOnSm: '/static/itxwebstandard/images/tienda-on-small.png',
                markerOff: '/static/itxwebstandard/images/tienda-off.png',
                markerOffSm: '/static/itxwebstandard/images/tienda-off-small.png',
                markerFavOn: '/static/itxwebstandard/images/tienda-favorita-on.png',
                markerFavOnSm: '/static/itxwebstandard/images/tienda-favorita-on-small.png',
                markerFavOff: '/static/itxwebstandard/images/tienda-favorita-off.png',
                markerFavOffSm: '/static/itxwebstandard/images/tienda-favorita-off-small.png'
            },
            dropbox: {
                markerOn: '/static/itxwebstandard/images/tienda-on.png',
                markerOnSm: '/static/itxwebstandard/images/tienda-on-small.png',
                markerOff: '/static/itxwebstandard/images/tienda-off.png',
                markerOffSm: '/static/itxwebstandard/images/tienda-off-small.png',
                markerFavOn: '/static/itxwebstandard/images/tienda-favorita-on.png',
                markerFavOnSm: '/static/itxwebstandard/images/tienda-favorita-on-small.png',
                markerFavOff: '/static/itxwebstandard/images/tienda-favorita-off.png',
                markerFavOffSm: '/static/itxwebstandard/images/tienda-favorita-off-small.png'
            },
            itxdroppoint: {
                markerOn: '/static/itxwebstandard/images/tienda-on.png',
                markerOnSm: '/static/itxwebstandard/images/tienda-on-small.png',
                markerOff: '/static/itxwebstandard/images/tienda-off.png',
                markerOffSm: '/static/itxwebstandard/images/tienda-off-small.png',
                markerFavOn: '/static/itxwebstandard/images/tienda-favorita-on.png',
                markerFavOnSm: '/static/itxwebstandard/images/tienda-favorita-on-small.png',
                markerFavOff: '/static/itxwebstandard/images/tienda-favorita-off.png',
                markerFavOffSm: '/static/itxwebstandard/images/tienda-favorita-off-small.png'
            }
            
        },
        // type of element that is being loaded/changed in the new category/product page.
        productCategoryLoadType: {
            CATEGORY: 1,
            PRODUCT: 2,
            COLOR: 3
        },
        categoryLayout:{
            TWO_COLUMNS: 'two-columns',
            FOUR_COLUMNS: 'four-columns'
        },
        // image aspect ratio
        imageAspectRatio: 1.332,
        timezonesByCountryCode: {
            'AD': 'Europe/Andorra',
            'AE': 'Asia/Dubai',
            'AF': 'Asia/Kabul',
            'AG': 'America/Antigua',
            'AI': 'America/Anguilla',
            'AL': 'Europe/Tirane',
            'AM': 'Asia/Yerevan',
            'AO': 'Africa/Luanda',
            'AQ': 'Antarctica/McMurdo',
            'AR': 'America/Argentina/Buenos_Aires',
            'AS': 'Pacific/Pago_Pago',
            'AT': 'Europe/Vienna',
            'AU': 'Australia/Sydney',
            'AW': 'America/Aruba',
            'AX': 'Europe/Mariehamn',
            'AZ': 'Asia/Baku',
            'BA': 'Europe/Sarajevo',
            'BB': 'America/Barbados',
            'BD': 'Asia/Dhaka',
            'BE': 'Europe/Brussels',
            'BF': 'Africa/Ouagadougou',
            'BG': 'Europe/Sofia',
            'BH': 'Asia/Bahrain',
            'BI': 'Africa/Bujumbura',
            'BJ': 'Africa/Porto-Novo',
            'BL': 'America/St_Barthelemy',
            'BM': 'Atlantic/Bermuda',
            'BN': 'Asia/Brunei',
            'BO': 'America/La_Paz',
            'BQ': 'America/Kralendijk',
            'BR': 'America/Sao_Paulo',
            'BS': 'America/Nassau',
            'BT': 'Asia/Thimphu',
            'BW': 'Africa/Gaborone',
            'BY': 'Europe/Minsk',
            'BZ': 'America/Belize',
            'CA': 'America/Toronto',
            'CC': 'Indian/Cocos',
            'CD': 'Africa/Kinshasa',
            'CF': 'Africa/Bangui',
            'CG': 'Africa/Brazzaville',
            'CH': 'Europe/Zurich',
            'CI': 'Africa/Abidjan',
            'CK': 'Pacific/Rarotonga',
            'CL': 'America/Santiago',
            'CM': 'Africa/Douala',
            'CN': 'Asia/Shanghai',
            'CO': 'America/Bogota',
            'CR': 'America/Costa_Rica',
            'CU': 'America/Havana',
            'CV': 'Atlantic/Cape_Verde',
            'CW': 'America/Curacao',
            'CX': 'Indian/Christmas',
            'CY': 'Asia/Nicosia',
            'CZ': 'Europe/Prague',
            'DE': 'Europe/Berlin',
            'DJ': 'Africa/Djibouti',
            'DK': 'Europe/Copenhagen',
            'DM': 'America/Dominica',
            'DO': 'America/Santo_Domingo',
            'DZ': 'Africa/Algiers',
            'EC': 'America/Guayaquil',
            'EE': 'Europe/Tallinn',
            'EG': 'Africa/Cairo',
            'EH': 'Africa/El_Aaiun',
            'ER': 'Africa/Asmara',
            'ES': 'Europe/Madrid',
            'ET': 'Africa/Addis_Ababa',
            'FI': 'Europe/Helsinki',
            'FJ': 'Pacific/Fiji',
            'FK': 'Atlantic/Stanley',
            'FM': 'Pacific/Chuuk',
            'FO': 'Atlantic/Faroe',
            'FR': 'Europe/Paris',
            'GA': 'Africa/Libreville',
            'GB': 'Europe/London',
            'GD': 'America/Grenada',
            'GE': 'Asia/Tbilisi',
            'GF': 'America/Cayenne',
            'GG': 'Europe/Guernsey',
            'GH': 'Africa/Accra',
            'GI': 'Europe/Gibraltar',
            'GL': 'America/Godthab',
            'GM': 'Africa/Banjul',
            'GN': 'Africa/Conakry',
            'GP': 'America/Guadeloupe',
            'GQ': 'Africa/Malabo',
            'GR': 'Europe/Athens',
            'GS': 'Atlantic/South_Georgia',
            'GT': 'America/Guatemala',
            'GU': 'Pacific/Guam',
            'GW': 'Africa/Bissau',
            'GY': 'America/Guyana',
            'HK': 'Asia/Hong_Kong',
            'HN': 'America/Tegucigalpa',
            'HR': 'Europe/Zagreb',
            'HT': 'America/Port-au-Prince',
            'HU': 'Europe/Budapest',
            'IC': 'Atlantic/Canary',
            'ID': 'Asia/Jakarta',
            'IE': 'Europe/Dublin',
            'IL': 'Asia/Jerusalem',
            'IM': 'Europe/Isle_of_Man',
            'IN': 'Asia/Kolkata',
            'IO': 'Indian/Chagos',
            'IQ': 'Asia/Baghdad',
            'IR': 'Asia/Tehran',
            'IS': 'Atlantic/Reykjavik',
            'IT': 'Europe/Rome',
            'JE': 'Europe/Jersey',
            'JM': 'America/Jamaica',
            'JO': 'Asia/Amman',
            'JP': 'Asia/Tokyo',
            'KE': 'Africa/Nairobi',
            'KG': 'Asia/Bishkek',
            'KH': 'Asia/Phnom_Penh',
            'KI': 'Pacific/Tarawa',
            'KM': 'Indian/Comoro',
            'KN': 'America/St_Kitts',
            'KP': 'Asia/Pyongyang',
            'KR': 'Asia/Seoul',
            'KW': 'Asia/Kuwait',
            'KY': 'America/Cayman',
            'KZ': 'Asia/Almaty',
            'LA': 'Asia/Vientiane',
            'LB': 'Asia/Beirut',
            'LC': 'America/St_Lucia',
            'LI': 'Europe/Vaduz',
            'LK': 'Asia/Colombo',
            'LR': 'Africa/Monrovia',
            'LS': 'Africa/Maseru',
            'LT': 'Europe/Vilnius',
            'LU': 'Europe/Luxembourg',
            'LV': 'Europe/Riga',
            'LY': 'Africa/Tripoli',
            'MA': 'Africa/Casablanca',
            'MC': 'Europe/Monaco',
            'MD': 'Europe/Chisinau',
            'ME': 'Europe/Podgorica',
            'MF': 'America/Marigot',
            'MG': 'Indian/Antananarivo',
            'MH': 'Pacific/Majuro',
            'MK': 'Europe/Skopje',
            'ML': 'Africa/Bamako',
            'MM': 'Asia/Yangon',
            'MN': 'Asia/Ulaanbaatar',
            'MO': 'Asia/Macau',
            'MP': 'Pacific/Saipan',
            'MQ': 'America/Martinique',
            'MR': 'Africa/Nouakchott',
            'MS': 'America/Montserrat',
            'MT': 'Europe/Malta',
            'MU': 'Indian/Mauritius',
            'MV': 'Indian/Maldives',
            'MW': 'Africa/Blantyre',
            'MX': 'America/Mexico_City',
            'MY': 'Asia/Kuala_Lumpur',
            'MZ': 'Africa/Maputo',
            'NA': 'Africa/Windhoek',
            'NC': 'Pacific/Noumea',
            'NE': 'Africa/Niamey',
            'NF': 'Pacific/Norfolk',
            'NG': 'Africa/Lagos',
            'NI': 'America/Managua',
            'NL': 'Europe/Amsterdam',
            'NO': 'Europe/Oslo',
            'NP': 'Asia/Kathmandu',
            'NR': 'Pacific/Nauru',
            'NU': 'Pacific/Niue',
            'NZ': 'Pacific/Auckland',
            'OM': 'Asia/Muscat',
            'PA': 'America/Panama',
            'PE': 'America/Lima',
            'PF': 'Pacific/Tahiti',
            'PG': 'Pacific/Port_Moresby',
            'PH': 'Asia/Manila',
            'PK': 'Asia/Karachi',
            'PL': 'Europe/Warsaw',
            'PM': 'America/Miquelon',
            'PN': 'Pacific/Pitcairn',
            'PR': 'America/Puerto_Rico',
            'PS': 'Asia/Gaza',
            'PT': 'Europe/Lisbon',
            'PW': 'Pacific/Palau',
            'PY': 'America/Asuncion',
            'QA': 'Asia/Qatar',
            'RE': 'Indian/Reunion',
            'RO': 'Europe/Bucharest',
            'RS': 'Europe/Belgrade',
            'RU': 'Europe/Moscow',
            'RW': 'Africa/Kigali',
            'SA': 'Asia/Riyadh',
            'SB': 'Pacific/Guadalcanal',
            'SC': 'Indian/Mahe',
            'SD': 'Africa/Khartoum',
            'SE': 'Europe/Stockholm',
            'SG': 'Asia/Singapore',
            'SH': 'Atlantic/St_Helena',
            'SI': 'Europe/Ljubljana',
            'SJ': 'Arctic/Longyearbyen',
            'SK': 'Europe/Bratislava',
            'SL': 'Africa/Freetown',
            'SM': 'Europe/San_Marino',
            'SN': 'Africa/Dakar',
            'SO': 'Africa/Mogadishu',
            'SR': 'America/Paramaribo',
            'SS': 'Africa/Juba',
            'ST': 'Africa/Sao_Tome',
            'SV': 'America/El_Salvador',
            'SX': 'America/Lower_Princes',
            'SY': 'Asia/Damascus',
            'SZ': 'Africa/Mbabane',
            'TC': 'America/Grand_Turk',
            'TD': 'Africa/Ndjamena',
            'TF': 'Indian/Kerguelen',
            'TG': 'Africa/Lome',
            'TH': 'Asia/Bangkok',
            'TJ': 'Asia/Dushanbe',
            'TK': 'Pacific/Fakaofo',
            'TL': 'Asia/Dili',
            'TM': 'Asia/Ashgabat',
            'TN': 'Africa/Tunis',
            'TO': 'Pacific/Tongatapu',
            'TR': 'Europe/Istanbul',
            'TT': 'America/Port_of_Spain',
            'TV': 'Pacific/Funafuti',
            'TW': 'Asia/Taipei',
            'TZ': 'Africa/Dar_es_Salaam',
            'UA': 'Europe/Kiev',
            'UG': 'Africa/Kampala',
            'UM': 'Pacific/Wake',
            'US': 'America/New_York',
            'UY': 'America/Montevideo',
            'UZ': 'Asia/Tashkent',
            'VA': 'Europe/Vatican',
            'VC': 'America/St_Vincent',
            'VE': 'America/Caracas',
            'VG': 'America/Tortola',
            'VI': 'America/St_Thomas',
            'VN': 'Asia/Ho_Chi_Minh',
            'VU': 'Pacific/Efate',
            'WF': 'Pacific/Wallis',
            'WS': 'Pacific/Apia',
            'YE': 'Asia/Aden',
            'YT': 'Indian/Mayotte',
            'ZA': 'Africa/Johannesburg',
            'ZM': 'Africa/Lusaka',
            'ZW': 'Africa/Harare',
            'WW': 'Europe/Madrid',
            'XE': 'Asia/Dubai',
            'XK': 'Europe/Madrid'
        },
        wideEyesApiKey: 'e69751c62ef29f800896cf78bd0336d630e6d6ef'
    };

    angular.module('itxApp.common')
        .constant('ItxConstants', ItxConstants);

    /** Public */
    itxApp.common.ItxConstants = ItxConstants;

})(window.itxApp);
